import { RightsApi } from '@app/services/rights-service/rights-service';
import { enqueSnackAction } from '@app/store/snacks';
import { call, put } from 'redux-saga/effects';
import {
  deleteProductRightsAction,
  fetchProductRightsAction,
} from '../actions';

export function* deleteProductRightsSaga(
  action: ReturnType<typeof deleteProductRightsAction>
) {
  const { items } = action;

  try {
    yield call(RightsApi.deleteProductGroupRights, items);

    yield put(fetchProductRightsAction({}));
    yield put(
      enqueSnackAction({
        notification: {
          message: 'User has been successfully removed from product groups.',
          options: {
            variant: 'success',
          },
          key: 'product-rights-delete',
        },
      })
    );
  } catch (e) {
    console.log('Failed to delete product rights', e.message);
    if (
      e.response &&
      (e.response.status === 409 || e.response.status === 400)
    ) {
      yield put(
        enqueSnackAction({
          notification: {
            message: e.response.data.message,
            options: {
              variant: 'error',
            },
            key: 'product-rights-delete',
          },
        })
      );
    }
    yield put(
      enqueSnackAction({
        notification: {
          message: 'Something wrong...',
          options: {
            variant: 'error',
          },
          key: 'product-rights-delete',
        },
      })
    );
  }
}
